import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
// const BASE_URL = "https://dialgrid-api.greymatterz.com";
// const BASE_URL = "http://192.168.2.180:5002";

const apiClientInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor
apiClientInstance.interceptors.request.use(
  (config) => {
    const token = "cGhvbmVhcGk6UGhvbmVAQTFiMmMzZDQ=";
    if (token) {
      // config.headers.Authorization = `Bearer ${token}`;
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
// apiClientInstance.interceptors.response.use(
//   (response) => {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     return response;
//   },
//   (error) => {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     if (error.response && error.response.status === 401) {
//       logout();
//     }
//     return Promise.reject(error);
//   }
// );

const get = async (url, params = {}, config = {}) => {
  return apiClientInstance
    .get(url, { params, ...config })
    .then((res) => res.data);
};

const post = async (url, body = {}, config = {}) => {
  return apiClientInstance
    .post(url, body, { ...config })
    .then((res) => res.data);
};

const postFile = async (url, file, body = {}, config = {}) => {
  const formData = new FormData();

  formData.append("file", file);

  for (const key in body) {
    formData.append(key, body[key]);
  }

  return apiClientInstance
    .post(url, formData, {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
};

const postFiles = async (url, files, body = {}, config = {}) => {
  const formData = new FormData();

  files.forEach((file, index) => {
    formData.append(`files[${index}]`, file);
  });

  for (const key in body) {
    formData.append(key, body[key]);
  }

  return apiClientInstance
    .post(url, formData, {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
};

const put = async (url, body = {}, config = {}) => {
  return apiClientInstance
    .put(url, body, { ...config })
    .then((res) => res.data);
};

const patch = async (url, body = {}, config = {}) => {
  return apiClientInstance
    .patch(url, body, { ...config })
    .then((res) => res.data);
};

const del = async (url, body = {}, config = {}) => {
  return apiClientInstance
    .request({ method: "delete", url, data: body, ...config })
    .then((res) => res.data);
};

const apiClient = {
  get,
  post,
  put,
  patch,
  delete: del,
  postFile,
  postFiles,
};

export default apiClient;
